export const templates = {
  id: "wizard",
  config: "/wizard/:collectionId/:tab?",
  build: ({collectionId, tab}: {collectionId: string, tab: string}) => `/wizard/${collectionId}/${tab}`,
}
